import { slugify } from '../../base/utils/string';
import { baseContentRoutes, defaultConfig, getApi } from '../../base/defaultConfig';
import { footerLinks as BFFooterLinks } from '../BF/config';

export const config = {
  ...defaultConfig,
  'global.siteUrl': 'https://reach-promos.breakfreeholidays.co.uk/',
  'awin.enable': true,
  'global.brandName': 'Reach Promos',
  'google.gtm': 'GTM-NQN6259',
  'header.logo.height': 35,
  'socialMedia.telephone': 'tel:03448484534',
  'user.optin.emailOpt': true,
  'user.optin.smsOpt': true,
  'user.optin.thirdOpt': false,
  'payment.enable3DSecure': true,
  'logo.width': '152px',
  'header.showPromoLink': true,
  'header.showFAQLink': true,
  'header.showFerriesLink': true,
  'header.showMoreLink': true,
  siteCode: 'RP',
};

export const contentRoutes = [
  ...baseContentRoutes,
  { path: '/reach-promos-offers', pageId: '221' },
  { path: '/about-us', pageId: '254' },
  { path: '/offers', pageId: '1939' },
  { path: '/hotels', pageId: '1942' },
  { path: '/lodges-with-hot-tubs', pageId: '2263' },
  { path: '/frequently-asked-questions', pageId: '3932' },
  { path: '/how-it-works', pageId: '3935' },
];

export const footerLinks = BFFooterLinks;

export const urls = getApi('api');
